import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import { RequestsFormValues } from '../../models';
import { Colors } from '../../../../../assets';
import { Spacing } from '../../../../../assets/GlobalStyle/Variables';
import { FieldError } from './FieldError';

export const GeneticsForm: FC = () => {
  const {
    register,
    getValues,
    formState: { errors }
  } = useFormContext<RequestsFormValues>();

  const requiredAtLeastOne = () => {
    return (
      getValues('genetics.pcr') || getValues('genetics.medical') || 'Vyberte alespoň jednu možnost.'
    );
  };

  return (
    <Wrapper>
      <Section>
        <Row>
          <Col md={3}>
            <SectionLabel>Typ vyšetření</SectionLabel>
          </Col>
          <Col md={9}>
            <CheckList>
              <Check>
                <input
                  type="checkbox"
                  {...register('genetics.pcr', { validate: requiredAtLeastOne })}
                />
                <span>PCR</span>
              </Check>
              <Check>
                <input
                  type="checkbox"
                  {...register('genetics.medical', { validate: requiredAtLeastOne })}
                />
                <span>Zdravotnická genetika</span>
              </Check>
            </CheckList>
          </Col>
        </Row>
      </Section>
      <FieldError error={errors.genetics?.pcr || errors.genetics?.medical} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  padding: ${Spacing(3)} 0;
`;

const SectionLabel = styled.div`
  color: ${Colors.grey};
  font-weight: 700;
`;

const CheckList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing(2)};
`;

const Check = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  user-select: none;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
  }

  span {
    color: ${Colors.grey};
  }
`;
